import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMaterialIcons } from '@shared-interfaces/material-icons';

import { IMatCustomSvgIcons } from '../../../interfaces/custom-material-icons';

@Component({
  selector: 'app-modal-content-simple-text',
  templateUrl: './modal-content-simple-text.component.html',
  standalone: false,
})
export class ModalContentSimpleTextComponent implements OnInit {
  @Input() title: string | undefined;
  @Input() icon: IMaterialIcons | undefined;
  @Input() svgIcon?: IMatCustomSvgIcons;
  @Input() body: string | undefined;
  @Input() buttonText: string | undefined;
  @Input() buttonAction: string | undefined;
  @Input() webpageUrl: string | undefined;

  @Output() public readonly closed = new EventEmitter<boolean | undefined>();

  ngOnInit(): void {
    if (this.buttonText == null) this.buttonText = 'OK';
  }

  handleButtonClick() {
    if (!this.buttonAction) this.closed.emit(true);
    if (this.buttonAction === 'openLink') this.openWebPage();
  }

  openWebPage() {
    window.open(this.webpageUrl);
  }
}
